import {
    Box,
    Container,
    Card,
} from '@mui/material';
import { AppButton } from 'components/widgets/AppButton';
import PhoneInTalkIcon from '@mui/icons-material/PhoneInTalk';
import { AppHeroView } from 'components/utils/AppHeroView';
import { AppFaqView } from 'components/utils/AppFaqView';
import { useApp } from 'AppProvider';
import ContactUsPage from './ContactUsPage';

const FaqPage = () => {
    const { navigateToPage } = useApp()

    const faqCategories = {
        general: [
            {
                question: "What types of vehicles do you transport?",
                answer: "We specialize in transporting commercial vehicles, including chassis, fully built vehicles (FBVs), trucks, buses, and heavy equipment. Our fleet is equipped to handle various vehicle sizes and configurations."
            },
            {
                question: "What is your service coverage area?",
                answer: "We provide Pan-India services, covering all major industrial hubs and transport routes. Our network spans across Delhi-NCR, Mumbai, Chennai, Kolkata, Bangalore, and other key locations with strategic support points throughout the country."
            },
            {
                question: "How do you ensure vehicle safety during transport?",
                answer: "We employ multiple safety measures including GPS tracking, experienced drivers, proper securing equipment, and comprehensive insurance coverage. All our transport vehicles are regularly maintained and equipped with modern safety features."
            }
        ],
        booking: [
            {
                question: "How do I book your transport service?",
                answer: "You can book our services through multiple channels: Call our 24/7 helpline, use our online booking form, or contact our regional offices. We'll need details about the vehicle, pickup location, destination, and preferred timeline."
            },
            {
                question: "What information do I need to provide for booking?",
                answer: "You'll need to provide: Vehicle details (type, dimensions, weight), pickup and delivery locations, preferred timing, any special handling requirements, and your contact information."
            },
            {
                question: "How far in advance should I book?",
                answer: "While we accommodate emergency requests, we recommend booking 2-3 days in advance for regular transport to ensure availability and optimal route planning."
            }
        ],
        pricing: [
            {
                question: "How is the transport cost calculated?",
                answer: "Our pricing is based on several factors: Distance, vehicle type, route complexity, fuel costs, and any special requirements. We provide transparent quotes with no hidden charges."
            },
            {
                question: "Do you offer insurance coverage?",
                answer: "Yes, all transports include comprehensive insurance coverage. We offer additional coverage options for high-value vehicles and special requirements."
            },
            {
                question: "What payment methods do you accept?",
                answer: "We accept various payment methods including NEFT/RTGS, credit/debit cards, and corporate payment terms for regular clients."
            }
        ],
        operations: [
            {
                question: "How do you handle emergency situations?",
                answer: "We have a 24/7 emergency response team and nationwide support network. In case of any issues, our team coordinates immediate assistance and provides regular updates."
            },
            {
                question: "Can I track my vehicle during transport?",
                answer: "Yes, we provide real-time GPS tracking through our customer portal. You'll receive regular updates and can contact our support team anytime for status updates."
            },
            {
                question: "What happens if there's a delay in delivery?",
                answer: "We immediately notify customers of any delays and provide regular updates. Our team works to minimize delays and find alternative solutions when necessary."
            }
        ]
    };

    return (
        <Box>
            {/* Hero Section */}
            <AppHeroView
                title="Frequently Asked Questions"
                description="Find answers to common questions about our chassis transport services."
            />

            {/* Search Section */}
            <AppFaqView maxWidth="md" sx={{ py: 4 }} faqCategories={faqCategories} />

            {/* Contact Section */}
            <Box sx={{ bgcolor: 'grey.100', py: 6, textAlign: "center" }}>
                <Container maxWidth="md">
                    <Card>
                        <AppHeroView
                            sx={{ py: 4 }}
                            title="Still have questions?"
                            description="Our support team is here to help 24/7"
                            titleProps={{ variant: 'h4', gutterBottom: true }}
                            descriptionProps={{ variant: 'subtitle1', paragraph: true }}
                            renderBottomContent={() => (
                                <AppButton variant="contained" color="primary" size="large" startIcon={<PhoneInTalkIcon />} onClick={() => navigateToPage(<ContactUsPage />)}>
                                    Contact Support
                                </AppButton>
                            )}
                        />
                    </Card>
                </Container>
            </Box>
        </Box>
    );
};

export default FaqPage;
